import { BoxDimension, UnitType } from "@store/reducers/init/types"

export const makeFirstLetterCap = (value: string) => {
  if (!value) {
    console.log("Please provide a value to Capatilize")
    return ""
  }
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const camalize = function camalize(str: any) {
  const arr = str.toLowerCase().split(" ")
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
  }
  const str2 = arr.join(" ")
  return str2
}

export const toBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

const pxToInchFactor = 0.0104166667
const pxToCmFactor = 0.0264583333
const mmToPxFactor = 3.7795275591

export const pixelToInches = (data: number, fractionDigits = 3) => {
  return Number((data * pxToInchFactor).toFixed(fractionDigits))
}

export const pixelToCm = (data: number) => {
  return Number((data * pxToCmFactor).toFixed(2))
}

export const inchesToPixel = (data: number) => {
  return Number((data / pxToInchFactor).toFixed(2))
}

export const mmToPixel = (data: number) => {
  return Number((data * mmToPxFactor).toFixed(2))
}

export const cmToPixel = (data: number) => {
  return Number((data / pxToCmFactor).toFixed(2))
}

export const convertToPixels = (value: number | string | BoxDimension, unitType: UnitType) => {
  function convert(value, unitType) {
    if (typeof value === "string") {
      value = Number(value)
    }
    if (unitType === "inch") {
      return inchesToPixel(value)
    }
    if (unitType === "cm") {
      return cmToPixel(value)
    }
    if (unitType === "pixel") {
      return value
    }
  }

  if (typeof value === "object") {
    return {
      width: convert(value.width || 0, unitType),
      height: convert(value.height || 0, unitType),
    }
  }
  return convert(value, unitType)
}

export const convertToUnit = (value: string | number | BoxDimension, unitType: UnitType) => {
  function convert(value, unitType) {
    if (typeof value === "string") {
      value = Number(value)
    }
    if (unitType === "inch") {
      return pixelToInches(value)
    }
    if (unitType === "cm") {
      return pixelToCm(value)
    }
    if (unitType === "pixel") {
      return value
    }
  }

  if (typeof value === "object") {
    return {
      width: convert(value.width || 0, unitType),
      height: convert(value.height || 0, unitType),
    }
  }
  return convert(value, unitType)
}
